//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    value: {
      type: String,
      default: ""
    },
    maximumHeight: {
      type: null,
      default: null
    },
    maxLength: {
      type: [String, Number],
      default: null
    },
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
      this.$nextTick(() => {
        this.resize();
      });
    },
    localValue() {
      this.$emit("input", this.localValue);
    }
  },
  mounted() {
    this.$nextTick(() => {
      const style = this.$el.getAttribute("style");
      this.$el.setAttribute("style", `${style} height: ${this.$el.scrollHeight}px`);
    });
  },
  methods: {
    resize() {
      const sh = this.$el.scrollHeight;
      const target = this.$el;
      target.style.height = "auto";
      if (this.maximumHeight && sh > this.maximumHeight) {
        target.style.height = `${this.maximumHeight}px`;
      } else {
        target.style.height = `${sh}px`;
      }
    },
    handleInput(event) {
      this.resize(event);
    },
    handleChange() {
      this.$emit("change", this.localValue);
    },
    handleKeyUp() {
      this.$emit("keyup", this.localValue);
    }
  }
});